<template>
  <div class="row">
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 score_sec">
      <span class="progress_block float-left ml-0" style="height: 32px; width: 70px;">
        <span class="state" :class="statusClass(competencySummary.performance, hideScoreForStudent)" style="height: 32px; width: 70px;">
          <span v-if="isScoreNotAvailable || hideScoreForStudent" class="progress_val ace_sec_txt" style="font-size: 15px;">N/A</span>
          <span v-else class="progress_val ace_sec_txt" style="font-size: 15px;">{{competencySummary.performance}}%</span>
        </span>
      </span>
        <b-link
          class="score_modify_indicator"
          v-b-modal="'overrideModal_' + competencySummary.uuid + index"
          v-if="competencySummary.overriddenTime"
          :title="$t('modifiedScoreTitle')"
          v-b-tooltip.hover>
        </b-link>
      <div class="modal_popup_container custom_modal_v4 course_unlock_modal">
      <b-modal :title="competencySummary.titleForStudent" class="description_modal" :id="'overrideModal_' + competencySummary.uuid + index" ok-only ok-title="ok">

        <div class="row">
          <div class="col-6 fld_label">
            Actual Overall Score
          </div>
          <div class="col-6 fld_val">
            {{competencySummary.prePerformance?competencySummary.prePerformance:0}}%
          </div>
        </div>
        <div class="row">
          <div class="col-6 fld_label">
            Edited Overall Score
          </div>
          <div class="col-6 fld_val">
            {{competencySummary.performance}}%
          </div>
        </div>
        <div class="row">
          <div class="col-6 fld_label">
            Actual Overall Progress
          </div>
          <div class="col-6 fld_val">
            <div class="progress-bar-label">
              {{competencySummary.preChildrenCompleteCount}} of {{competencySummary.childrenCount}}
            </div>
            <b-progress :max="competencySummary.childrenCount">
              <b-progress-bar :value="competencySummary.preChildrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
            </b-progress>
          </div>
        </div>
        <div class="row">
          <div class="col-6 fld_label">
            Edited Overall Progress
          </div>
          <div class="col-6 fld_val">
            <div class="progress-bar-label">
              {{competencySummary.childrenCompleteCount}} of {{competencySummary.childrenCount}}
            </div>
            <b-progress :max="competencySummary.childrenCount">
              <b-progress-bar :value="competencySummary.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
            </b-progress>
          </div>
        </div>
        <div class="row">
          <div class="col-12 fld_label">
            Edited By {{competencySummary.overriddenBy}} at  {{millisToDate(competencySummary.overriddenTime)}}
          </div>
        </div>

      </b-modal>
    </div>
      </span>
      <span class="score_lebel ml-0">
        {{ $tf('score') }}
      </span>
    </div>


    <div class="col-xl-8 col-lg-8 col-md-6 col-sm-12 progress_bar_sec">
      <div class="row">
        <div class="col-12 progress-row">
          <div class="progress-bar-label">{{mcSummary.childrenCompleteCount}} of {{mcSummary.childrenCount}}</div>
          <b-progress :max="mcSummary.childrenCount">
            <b-progress-bar :value="mcSummary.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
          </b-progress>
        </div>
        <div class="col-12 lnk_container" v-if="courseDetail.showDeadLine">
          <a href="javascript://" @click="navigateToObservationReport">Observation Report</a>
        </div>
        <div class="col-12 lnk_container" v-if="!waiveStatus" >
          <a href="javascript://" @click="launchCourse">{{getLaunchCourseLabel()}}</a>
        </div>
      </div>
    </div>
      <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="ssoCourseModal" class="description_modal" size="md" :id="'ssoModal_' + competencySummary.uuid" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">Reconfirm Credentials </div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="hideSsoCourseInfoModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-12 txt_row mt-3">
            We need to reconfirm your credentials, before you can access the course.
          </div>
          <div class="col-12 txt_row btn_container mt-3" style="text-align: right;">
            <b-button class="btn mr-3" @click="redirectToSsoLogin">login to course</b-button>
          </div>
        </div>

      </b-modal>
    </div>
  </div>

</template>


<script>
  import { DateTime } from 'luxon'
  import { mapState,mapActions } from 'vuex'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'program-course-score-and-progress-bar',
    props: ['courseId', 'hideScoreForStudent', 'waiveStatus'],
    data: () => {
      return {
        mcSummary: {},
        competencySummary: {},
        isScoreNotAvailable: true,
        userObject: JSON.parse(localStore.getItem('userobj')),
        courseDetail: {}
      }
    },
    mounted () {
      this.loadCourseProgress()
    },
    methods: {
      ...mapActions([
        'loadCompetencyProgress',
        'loadMicroCompetencyProgress',
        'loadContinueLearningLast',
        'loadCourseDetailFromServerWithoutStoringInState'
      ]),
      async loadCourseProgress () {
        this.mcSummary = await this.loadMicroCompetencyProgress({entityId: this.courseId, loadDataFromServer: true})
        this.competencySummary = await this.loadCompetencyProgress({entityId: this.courseId, loadDataFromServer: true})
        this.courseDetail = await this.loadCourseDetailFromServerWithoutStoringInState(this.courseId)
        if (!this.competencySummary.performance) {
          this.competencySummary.performance = 0
        }else{
            this.competencySummary.performance = this.competencySummary.performance.toFixed(2)
        }
        let status = this.competencySummary.status
        if ((status === 1) || (status === 2)) {
          this.isScoreNotAvailable = false
        }
        let data = {
          status: status,
          performance: this.competencySummary.performance,
          childrenCount: this.mcSummary.childrenCount,
          childrenCompleteCount: this.mcSummary.childrenCompleteCount
        }
        this.$emit('progressSummary', data)
      },
      statusClass (performance, hideScoreForStudent) {
        if (performance && !this.isScoreNotAvailable && !hideScoreForStudent) {
          if (performance >= 90) {
            return 'gradeA'
          } else if (performance >= 80 && performance < 90) {
            return 'gradeB'
          } else if (performance >= 65 && performance < 80) {
            return 'gradeC'
          } else if (performance >= 40 && performance < 65) {
            return 'gradeD'
          } else if (performance < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
      getLaunchCourseLabel () {
        if (this.competencySummary.status < 2) {
          return (this.competencySummary.status === 0) ? this.$t('startLearning') : this.$t('continueLearning')
        } else {
            return 'View Course'
        }
      },
      hideSsoCourseInfoModal () {
        this.$refs.ssoCourseModal.hide()
      },
      redirectToSsoLogin (){
          let ssoPath = this.institution.path
          localStorage.clear()
          window.location.href = '/sso/'+ssoPath
      },
      navigateToObservationReport () {
        return this.$router.push({name: 'learnerObservationReport', params: {uuid: this.courseId}})
      },
      millisToDate (millis) {
        return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
      },

      launchCourse () {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        this.$store.commit('LOAD_COURSE_TOPICS', {})
        this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
        this.loadContinueLearningLast({uuid: this.courseId, loadDataFromServer: true}).then(options => {
          if (options && options.length > 0) {
            if (options[0].title === 'EXTRENAL_COURSE_LAUNCH' && options[0].type ==='SSOCOURSE' && !this.userObject.ssoLogin) {
              this.$refs.ssoCourseModal.show()
              return
            }else {
              if (options[0].title === 'EXTRENAL_COURSE_LAUNCH') {
                let _window = window.open(options[0].uri, '_blank')
                 setTimeout(() => {
                    _window.location = options[1].uri
                  }, 5000)
                return
              }
              if (options[0].title === 'PARTNER_COURSE_LAUNCH') {
                  window.location.href = options[0].uri
                return
              }

              if (options[0].title !== 'COURSE_FINISHED') {
                return this.$router.push({name: 'courseDashboard', params: {uuid: this.courseId, showLastActivity: true}})
              }
             }
          }
          return this.$router.push({name: 'courseDashboard', params: {uuid: this.courseId}})
        })
      }
    },
    computed: {
      ...mapState({
        'institution': state => state.institution.institution
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramCourseScoreAndProgressBar.vue